export const getIframeDomain = iframe => {
  const url = new URL(iframe.src);
  return url.origin;
};